import styled from "styled-components";

export const Subtitle = styled.h3`
  font-size: 1.3rem;
`;
